module.exports = __webpack_public_path__ + "assets/img/skill.0f192713.png";